<template>
    <el-dialog width="40%" center :title="titleval" :visible.sync="visible" :close-on-click-modal="false"
        :before-close="coinClose">
        <div style="margin: 0 20%;">
            <div v-if="title == 1">
                <el-form ref="formInline" :model="formInline" :rules="ruleInline" class="form-inner">
                    <el-form-item prop="user">
                        <el-input name="user" type="text" v-model="formInline.user"
                            :placeholder="$t('uc.login.loginvalidate')" class="user">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" class="password">
                        <el-input show-password type="password" v-model="formInline.password"
                            :placeholder="$t('uc.login.pwdtip')" @on-keyup="onKeyup">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div style="margin-bottom: 10px; height: 30px;">
                    <div style="float: left;">
                        <span>{{ $t('uc.login.noaccount') }}</span>
                        <router-link to="/register"></router-link>
                        <span style="color:#551A88;" @click="title = '2'"> {{ $t('uc.login.goregister') }}</span>
                    </div>
                    <div style="float:right; color:#0173e5;" @click="title = '3'">
                        {{ $t('uc.login.forget') }}
                    </div>
                </div>
                <div style="text-align: center; font-size: 16px;">
                    <span @click="qrCode">{{ $t('uc.finance.recharge.qrcode') }}{{ $t("common.login") }}</span>
                </div>


            </div>
            <div v-if="title == 2">
                <el-form ref="formInline" :model="formInline" :rules="ruleInline" class="form-inner">
                    <el-radio-group size="mini" v-model="changeActive" style="margin-bottom: 10px; ">
                        <el-radio-button label="email">{{ $store.getters.lang =='zh_CN'?$t('uc.forget.memail'): 'E-mail'  }}</el-radio-button>
                        <el-radio-button label="name">{{ $t('uc.regist.username') }}</el-radio-button>
                        <el-radio-button v-if="$store.getters.configList.hasPhone" label="telno">{{ $t('uc.forget.mtelno') }}</el-radio-button>
                        
                    </el-radio-group>
                    <el-form-item prop="user" v-if="changeActive == 'telno'">
                        <el-select filterable clearable style="width: 20%;" v-model="country"
                            :placeholder="$t('uc.regist.telno')">
                            <el-option v-for="item in countryList" :key="item.areaCode" :label="item.areaCode"
                                :value="item.zhName">
                            </el-option>
                        </el-select>
                        <el-input style="width: 78%;" type="text" v-model="formInline.user" autocomplete="off"
                            :placeholder="$t('uc.regist.telno')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="user" v-if="changeActive == 'email'">
                        <el-input type="text" v-model="formInline.user" autocomplete="off"
                            :placeholder="$t('uc.regist.email')">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="changeActive == 'name'" prop="username" class="username">
                        <el-input v-model="formInline.username" :placeholder="$t('uc.regist.username')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop=" code1">
                        <div class="code-wrap">
                            <el-input :placeholder="$t('uc.regist.smscode')" v-model="formInline.code1">
                                <template slot="append"> <span v-if="changeActive == 'telno'" style="cursor: pointe"
                                        @click="sendCode2">{{ codedisabled3 ?
                                            time
                                            + $t('uc.safe.second') : $t('uc.forget.sendcode') }}</span>
                                    <span v-if="changeActive == 'email'" style="cursor: pointe" @click="sendCode2">{{
                                        codedisabled1 ?
                                        time1
                                        + $t('uc.safe.second') : $t('uc.forget.sendcode') }}</span>
                                    <span v-if="changeActive == 'name'" style="cursor: pointe;width:60px;height:30px">
                                        <img @click="sendCodename" :src="logimg"
                                            style='vertical-align: middle;width:80px;height:30px' /></span></template>
                            </el-input>

                        </div>
                    </el-form-item>

                    <el-form-item prop="password" class="password">
                        <el-input show-password type="password" autocomplete="new-password" v-model="formInline.password"
                            :placeholder="$t('uc.regist.pwd')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="repassword" class="password">
                        <el-input show-password type="password" v-model="formInline.repassword"
                            :placeholder="$t('uc.regist.repwd')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="promotion">
                        <el-input type="text" v-model="formInline.promotion">
                            <span slot="prepend" style="margin-left: 7px;">{{ $t('uc.regist.promotion') }} :</span>
                        </el-input>
                    </el-form-item>
                    <div class="check-agree" style="">
                        <label>
                            <el-checkbox v-model="agree">{{ $t('uc.regist.agreement') }}</el-checkbox>
                        </label>
                        <a @click="$router.push(`/helplist?cate=7&cateTitle=${$t('uc.regist.userprotocol')}`)"
                            target="_blank" style="color: #409eff;">《{{
                                $t('uc.regist.userprotocol') }}》</a>
                    </div>
                </el-form>

            </div>
            <div v-if="title == 3">
                <el-form ref="formInline" :model="formInline" :rules="ruleInline" class="form-inner">
                    <el-form-item prop="user">
                        <el-input type="text" v-model="formInline.user" autocomplete="off"
                            :placeholder="$t('uc.regist.email')" v-if="changeActive == 'email'">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop=" code1">
                        <div class="code-wrap">
                            <el-input :placeholder="$t('uc.regist.smscode')" v-model="formInline.code1">
                                <template slot="append"> <span style="cursor: pointe" @click="sendCode">{{ codedisabled ?
                                    countdown
                                    + $t('uc.safe.second') : $t('uc.forget.sendcode') }}</span> </template>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password" class="password">
                        <el-input show-password type="password" autocomplete="new-password" v-model="formInline.password"
                            :placeholder="$t('uc.regist.pwd')">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="repassword" class="password">
                        <el-input show-password type="password" v-model="formInline.repassword"
                            :placeholder="$t('uc.regist.repwd')">
                        </el-input>
                    </el-form-item>
                </el-form>

            </div>
            <div v-if="title == 4">
                <!-- <el-dialog :close-on-click-modal='false' :title="$t('uc.finance.recharge.qrcode') + $t('common.login')"
                    :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
                    <qriously v-if="qrcode.value" :value="qrcode.value" :size="qrcode.size" foreground="#000" />
                </el-dialog> -->
                <qriously v-if="qrcode.value" :value="qrcode.value" :size="qrcode.size" foreground="#000" />

            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="title != 4" type="primary" @click="handleSubmit">{{ titleval
            }}</el-button>
        </span>

    </el-dialog>
</template>
  
<script>
import Vue from "vue";
import CryptoJS from 'crypto-js'
import VueQriously from "vue-qriously";
Vue.use(VueQriously);
export default {
    components: {
        VueQriously,
    },
    name: 'MyDialog',
    props: {
        titles: String,
    },
    data() {
        const validpassword = (rule, value, callback) => {
            if (value == "") {
                callback(new Error(this.$t("uc.regist.pwdtip")));
            } else if (value.length < 6) {
                callback(new Error(this.$t("uc.regist.pwdmsg")));
            } else {
                callback();
            }
        };
        const validuser = (rule, value, callback) => {
            if (value == "") {
                callback(new Error(this.$t("uc.login.loginvalidate")));
            } else {
                callback();
            }
        };
        const validcode1 = (rule, value, callback) => {
            if (value == "") {
                callback(new Error(this.$t("uc.regist.smscodetip")));
            } else {
                callback();
            }
        };
        const validateRepassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error(this.$t("uc.regist.confirmpwdtip")));
            } else if (value !== this.formInline.password) {
                callback(new Error(this.$t("uc.regist.confirmpwderr")));
            } else {
                callback();
            }
        };
        const validpromotion = (rule, value, callback) => {
            if (value == "") {
                callback(new Error(this.$t('option.enter')));
            } else {
                callback();
            }
        };
        return {
            countdown: 120,
            cid: Math.floor(Math.random() * 999999),
            logimg: '',
            countryList: [],
            country: "",
            codedisabled: false,
            dialogVisible: false,
            title: '',
            visible: true,
            Ttimer: undefined,
            timers: 0,
            changeActive: "email",
            registing: false,
            codedisabled3: false,
            codedisabled1: false,
            time: 120,
            time1: 120,
            qrcode: {
                value: "",
                size: 280,
                coinName: "",
                unit: ""
            },
            agree: true,
            formInline: {
                user: "",
                password: "",
                username: "",
                // user: "",
                code1: "",
                areaCode: "",
                password: "",
                repassword: "",
            },
            ruleInline: {
                // user: [{ validator: validuser, trigger: "blur" }],
                // password: [{ validator: validpassword, trigger: "blur" }],
                // code1: [{ validator: validcode1, trigger: "blur" }],
                // repassword: [{ validator: validateRepassword, trigger: "blur" }],
                // promotion: [{ validator: validpromotion, trigger: "blur" }],
            },
        }
    },
    computed: {
        titleval: function () {
            if (this.title == 1) {
                return this.$t('common.login')
            } else if (this.title == 2) {
                return this.$t('uc.login.register')
            } else if (this.title == 3) {
                return this.$t('uc.forget.title')
            } else {
                return this.$t('uc.finance.recharge.qrcode') + this.$t('common.login')
            }

        },
    },
    created() {
        this.title = this.titles
        this.logimg = `${this.host}/uc/register/captcha?cid=${this.cid}`;
        this.getCountry();
    },

    methods: {
        sendCodename() {
            this.cid = Math.floor(Math.random() * 999999)
            this.logimg = `${this.host}/uc/register/captcha?cid=${this.cid}`;
        },
        getCountry() {
            this.$http
                .post(this.host + "/uc/support/country")
                .then((response) => {
                    var resp = response.body;
                    if (resp.code == 0) {
                        this.countryList = resp.data
                    } else {
                        this.$Message.error(this.$t('common.logintip'));
                    }
                });
        },
        coinClose() {
            this.$emit('loginisval', false)
            this.empty()
            if (this.title == 4) {
                clearInterval(this.Ttimer)
            }
        },
        ok() {
            this.$emit('ok')

        },
        //登录
        handleClose() {
            this.dialogVisible = false
            this.timers = 0
        },
        qrCode() {

            this.$http.post(this.host + "/auth/dapp/pc-login/qr", {}).then((response) => {
                var resp = response.body;
                if (resp.code == 0) {
                    this.title = 4
                    let arrdata = {
                        url: resp.data.url,
                        webId: resp.data.webId,
                    }
                    this.qrcode.value = 'ospn://weblogin/' + JSON.stringify(arrdata)
                    // this.dialogVisible = true
                    this.webId = resp.data.webId
                    this.Ttimer = setInterval(() => {
                        this.gitSetting()
                        this.timers = this.timers + 1
                        if (this.timers == 180) {
                            clearInterval(this.Ttimer)
                        }
                    }, 1000)

                } else {
                }
            });

        },
        gitSetting() {
            this.$http.post(this.host + "/auth/dapp/pc-login/check", { webId: this.webId }).then((response) => {
                var resp = response.body;
                if (resp.code == 0) {
                    if (resp.data) {
                        clearInterval(this.Ttimer)
                        this.$Message.success(this.$t("uc.login.success"));
                        // this.decodeWebId(resp.data)
                        this.$store.commit("setMember", resp.data);
                        // localStorage.setItem("TOKEN", resp.data.token);
                        this.$router.push("/");
                        this.timers = 0
                        this.coinClose()
                        localStorage.setItem("ISLOGINS", 1);
                        if (
                            this.$route.query.key != null &&
                            this.$route.query.key != ""
                        ) {
                            localStorage.setItem("USERKEY", this.$route.query.key);
                        }
                    }
                } else {
                }
            });

        },
        onKeyup(ev) {
            if (ev.keyCode == 13) {
                $(".login_btn").click();
            }
        },
        empty() {
            this.formInline.password = ''
            this.formInline.user = ''
            this.formInline.repassword = ''
            this.formInline.username = ''
            this.formInline.code1 = ''
            this.formInline.areaCode = ''
        },
        handleSubmit(name = "formInline") {
            if (this.title == 1) {
                if (!this.formInline.user) return this.$Message.error(this.$t("uc.login.loginvalidate"));
                if (!this.formInline.password) return this.$Message.error(this.$t("uc.regist.pwdtip"));
            } else if (this.title == 2) {
                if (!this.formInline.promotion) return this.$Message.error(this.$t('option.enter'));
                if (!this.formInline.repassword) return this.$Message.error(this.$t("uc.regist.confirmpwderr"));
                if (!this.formInline.password) return this.$Message.error(this.$t('option.enter'));
                if (this.changeActive == "name" && !this.formInline.username) return this.$Message.error(this.$t("uc.login.loginvalidate"));
                if (this.changeActive == "email" && !this.formInline.user) return this.$Message.error(this.$t("uc.regist.emailtip"));
                if (this.changeActive == "telno" && !this.formInline.user) return this.$Message.error(this.$t("uc.regist.teltip"));
            } else if (this.title == 3) {
                if (!this.formInline.repassword) return this.$Message.error(this.$t("uc.regist.confirmpwderr"));
                if (!this.formInline.password) return this.$Message.error(this.$t('option.enter'));
                if (!this.formInline.user) return this.$Message.error(this.$t("uc.regist.emailtip"));
            }
            // 不带验证
            this.$refs.formInline.validate((valid) => {
                if (valid) {
                    if (this.title == 1) {
                        this.$http
                            .get(this.host + '/auth/pre/login' + `?username=${this.formInline.user}`)
                            .then((response) => {
                                var resp = response.body
                                if (resp.code == 0) {
                                    var key = this.Encrypt(resp.data, this.formInline.password);
                                    if (key) {
                                        this.preLogin(encodeURIComponent(key.toString()))
                                    }
                                } else {
                                    this.$Message.error(resp.message);
                                }
                            });

                    } else if (this.title == 3) {
                        var params = {
                            email: this.formInline.user,
                            code: this.formInline.code1,
                            password: this.formInline.password
                        };
                        this.$http
                            .post(this.host + "/uc/reset/login/password/email", JSON.stringify(params))
                            .then((response) => {
                                var resp = response.body;
                                if (resp.code == 0) {
                                    this.$Message.success(resp.message);
                                    this.title = 1
                                    this.empty()
                                } else {
                                    this.$Message.error(resp.message);
                                }
                            });


                    } else {
                        if (this.agree == true) {
                            if (this.changeActive == "email") {
                                if (this.isRegister) {
                                    this.registing = true;
                                    let params = {
                                        email: this.formInline.user,
                                        username: this.formInline.username + this.formInline.user,
                                        password: this.formInline.password,
                                        promotion: this.formInline.promotion,
                                        code: this.formInline.code1,
                                        country: this.country,
                                        superPartner: '',
                                        // ticket: this.ticket,
                                        // randStr: this.randStr,
                                        visitCode: this.formInline.visitPassword
                                    };
                                    // var params = {};
                                    // params["email"] = this.formInline.user;
                                    // params["username"] =
                                    //     this.formInline.username + this.formInline.user;
                                    // params["password"] = this.formInline.password;
                                    // params["promotion"] = this.formInline.promotion; // 邀请码
                                    // params["country"] = this.country; //"中国";
                                    // params["superPartner"] = ""; //this.formInline.superType;
                                    // params["code"] = this.formInline.code1;
                                    // params["visitCode"] = this.formInline.visitPassword;

                                    this.$http
                                        .post(this.host + "/uc/v2/register/email", JSON.stringify(params))
                                        .then((response) => {
                                            this.registing = false;
                                            var resp = response.body;
                                            if (resp.code == 0) {
                                                if (
                                                    this.formInline.superType == "1" ||
                                                    this.formInline.superType == "2"
                                                ) {
                                                    this.$Message.success(resp.message);
                                                    setTimeout(() => {
                                                        that.$router.push("/");
                                                    }, 3000);
                                                } else {
                                                    this.$Message.success(resp.message);
                                                    setTimeout(() => {
                                                        // that.$router.push("/login");
                                                        this.title = '1'
                                                        this.empty()
                                                    }, 3000);
                                                }
                                            } else {
                                                this.$Message.error(resp.message);
                                            }
                                        });
                                } else {
                                    this.$Message.error(this.$t('uc.regist.smscode'));
                                }
                            } else if (this.changeActive == "name") {
                                var params = {
                                    cid: this.cid,
                                    password: this.formInline.password,
                                    username: this.formInline.username,
                                    promotion: this.formInline.promotion,
                                    code: this.formInline.code1,
                                };
                                this.$http
                                    .post(this.host + "/uc/v2/register/username", JSON.stringify(params))
                                    .then((response) => {
                                        var resp = response.body;
                                        if (resp.code == 0) {
                                            this.$Message.success(resp.message);
                                            setTimeout(() => {
                                                // this.$router.push("/login");
                                                this.title = '1'
                                                this.empty()
                                            }, 3000);
                                        } else {
                                            this.$Message.error(resp.message,);
                                        }
                                    });

                            } else {
                                if (this.isRegister) {
                                    this.registing = true;
                                    let params = {
                                        phone: this.formInline.user,
                                        username: this.formInline.username + this.formInline.user,
                                        password: this.formInline.password,
                                        promotion: this.formInline.promotion,
                                        code: this.formInline.code1,
                                        country: this.country,
                                        superPartner: '',
                                        ticket: this.ticket,
                                        randStr: this.randStr,
                                    };
                                    // params["phone"] = ;
                                    // params["username"] =
                                    //     params["password"] = this.formInline.password;
                                    // params["promotion"] = this.formInline.promotion; // 邀请码
                                    // params["code"] = this.formInline.code1;
                                    // params["country"] = this.country; //"中国";
                                    // params["superPartner"] = ""; //this.formInline.superType;
                                    // params["ticket"] = this.ticket;
                                    // params["randStr"] = this.randStr;

                                    this.$http
                                        .post(this.host + "/uc/v2/register/phone", JSON.stringify(params))
                                        .then((response) => {
                                            this.registing = false;
                                            var resp = response.body;
                                            if (resp.code == 0) {
                                                if (
                                                    this.formInline.superType == "1" ||
                                                    this.formInline.superType == "2"
                                                ) {
                                                    this.$Message.success(
                                                        resp.message
                                                    );
                                                    setTimeout(() => {
                                                        that.$router.push("/");
                                                    }, 3000);
                                                } else {
                                                    this.$Message.success(this.$t("common.tip"),);
                                                    setTimeout(() => {
                                                        // that.$router.push("/login");
                                                        this.title = '1'
                                                        this.empty()
                                                    }, 3000);
                                                }
                                            } else {
                                                this.$Message.error(this.$t("common.tip"),);
                                            }
                                        });
                                } else {
                                    this.$Message.error(this.$t('uc.regist.smscode'));
                                }
                            }
                        } else {
                            this.$Message.error(
                                this.$t("uc.regist.agreementtip"),
                            );
                        }
                    }

                } else {
                }
            });
        },
        preLogin(key) {
            const loading = this.$loading({
                lock: true,
                text: this.$t('common.logins'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http
                .get(this.host + '/auth/login' + `?username=${this.formInline.user}&data=${key}`)
                .then((res) => {
                    if (res.body.code == 0) {
                        loading.close();
                        this.decode(res.body.data)
                        this.$router.push("/");
                        this.coinClose()
                        setTimeout(this.$Message.success(this.$t("uc.login.success")), 1000);
                        if (
                            this.$route.query.key != null &&
                            this.$route.query.key != ""
                        ) {
                            localStorage.setItem("USERKEY", this.$route.query.key);
                        }
                    } else {
                        loading.close();
                        this.$Message.error(res.body.message);
                    }
                });
        },
        //加密方法
        Encrypt(loginKey, word) {
            const key = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(word));
            const aseKey = CryptoJS.SHA256(key);
            let encrypted = CryptoJS.AES.encrypt(loginKey, aseKey, {
                iv: CryptoJS.enc.Utf8.parse(key.substr(0, 16)),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            //将结果进行base64加密
            return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        },
        //解密方法
        decode(dataval) {
            const key = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(this.formInline.password));
            const aseKey = CryptoJS.SHA256(key);
            const iv = CryptoJS.enc.Utf8.parse(key.substr(0, 16));
            var decrypt = CryptoJS.AES.decrypt(dataval, aseKey, {
                iv: CryptoJS.enc.Utf8.parse(key.substr(0, 16)),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            var resdata = decrypt.toString(CryptoJS.enc.Utf8).toString()
            this.$store.commit("setMember", JSON.parse(resdata));
        },
        //注册
        sendCode2() {
            if (this.changeActive == "name") {
                this.$http
                    .post(this.host + "/uc/register/captcha",)
                    .then((response) => {
                        var resp = response.body;
                        if (resp.code == 0) {
                            console.log(resp.data);
                        } else {
                            this.$Message.error(resp.message);
                        }
                    });
            }
            if (this.codedisabled3 || this.codedisabled1) return
            var mobilePhone = this.formInline.user;
            if (this.changeActive == "telno" || mobilePhone != '') {
                this.isRegister = true;
                this.success2();
            } else {
                this.$Message.error(this.$t("uc.regist.emailtip"));
                return;
            }
        },
        success2() {
            if (this.changeActive == "telno") {
                var params = {};
                params["phone"] = this.formInline.user;
                params["country"] = this.country;
                this.$http
                    .post(this.host + "/uc/mobile/code", JSON.stringify(params))
                    .then((response) => {
                        var resp = response.body;
                        if (resp.code == 0) {
                            this.$Message.success(resp.message);
                            this.codedisabled3 = true;
                            let interval = window.setInterval(() => {
                                this.time--;
                                if (this.time <= 0) {
                                    this.time = 120;
                                    this.codedisabled3 = false;
                                    window.clearInterval(interval);
                                }
                            }, 1000);
                        } else {
                            this.$Message.error(resp.message,);
                        }
                    });
            } else {
                this.$http
                    .get(this.host + "/uc/reg/email/code" + `?email=${this.formInline.user}`)
                    .then((response) => {
                        var resp = response.body;
                        if (resp.code == 0) {
                            this.$Message.success(resp.message);
                            this.codedisabled1 = true;
                            let interval1 = window.setInterval(() => {
                                this.time1--;
                                if (this.time1 <= 0) {
                                    this.time1 = 120;
                                    this.codedisabled1 = false;
                                    window.clearInterval(interval1);
                                }
                            }, 1000);

                        } else {
                            this.$Message.error(resp.message,);
                        }
                    });
            }
        },

        //忘记密码
        sendCode() {
            if (this.codedisabled) return
            var mobilePhone = this.formInline.user;
            if (this.changeActive == "telno" || mobilePhone != '') {
                this.isRegister = true;
                this.success();
            } else {
                this.$Message.error(this.$t("uc.regist.emailtip"));
                return;
            }
        },
        success() {
            this.$http
                .get(this.host + "/uc/reset/email/code" + `?email=${this.formInline.user}&agentId=${this.$store.getters.id == undefined ? '' : this.$store.getters.id}`,
                )
                .then((response) => {
                    this.countdown = 120;
                    var resp = response.body;
                    if (resp.code == 0) {
                        this.$Message.success(resp.message);
                        this.codedisabled = true;
                        let interval = window.setInterval(() => {
                            this.countdown--;
                            if (this.countdown <= 0) {
                                this.countdown = 120;
                                this.codedisabled = false;
                                window.clearInterval(interval);
                            }
                        }, 1000);
                    } else {
                        this.$Message.error(resp.message);
                    }
                });
        },
    }
}
</script>
  
  


// WEBPACK FOOTER //
// src/components/logins.vue